import type en from "../en/builder";
import type { Messages } from "../../types";

const ar: Messages<typeof en> = {
  // Server action messages
  errUnknownPage: "صفحة غير معروفة",
  errInvalidContent: "محتوى الصفحة غير صالح",
  errInvalidSettings: "إعدادات غير صالحة",
  errUnknownRevision: "مراجعة غير معروفة",
  errUnknownMenu: "قائمة غير معروفة",
  errInvalidMenu: "قائمة غير صالحة",
  errUnknownFile: "ملف غير معروف",
  errAltTooLong: "يجب ألا يتجاوز النص البديل 300 حرف.",
  errTooLong: "طويل جدًا",
  publishedLive: "أصبحت «{title}» وأنماط القالب منشورة الآن.",
  themeChanged: "تم تغيير القالب. انشر التغييرات لتظهر في متجرك.",
  pageSettingsSaved: "تم حفظ إعدادات الصفحة.",
  unpublishedMsg: "تم إلغاء النشر",
  draftDiscarded: "تم تجاهل المسودة",
  revisionRestored: "تمت الاستعادة إلى المسودة. راجعها في المنشئ ثم انشرها.",
  markedReviewed: "تم التعليم كمراجَع",
  menuSaved: "تم حفظ القائمة — وهي منشورة الآن في متجرك.",
  altSaved: "تم حفظ النص البديل",

  // Builder page / editor
  noPagesYet: "لا توجد صفحات بعد",
  noPagesBuilderDesc: "أنشئ صفحة أولًا، ثم صمّمها هنا.",
  goToPages: "الانتقال إلى الصفحات",
  exitBuilder: "الخروج من المنشئ",
  pageToEdit: "الصفحة المراد تعديلها",
  homeSuffix: "الرئيسية",
  previewSize: "حجم المعاينة",
  previewDesktop: "معاينة سطح المكتب",
  previewTablet: "معاينة الجهاز اللوحي",
  previewMobile: "معاينة الهاتف",
  undoShortcut: "تراجع (Ctrl+Z)",
  redoShortcut: "إعادة (Ctrl+Shift+Z)",
  pageNotLive: "تحتوي هذه الصفحة على تغييرات غير منشورة",
  themeNotLive: "تحتوي أنماط القالب على تغييرات غير منشورة",
  notLiveYet: "غير منشور بعد",
  previewNewTab: "المعاينة في علامة تبويب جديدة",
  notSaved: "لم يُحفظ: {error}",
  editorPanels: "لوحات المحرّر",
  pageStructure: "بنية الصفحة والقالب",
  editorTools: "أدوات المحرّر",
  tabSections: "الأقسام",
  tabText: "النص",
  tabTheme: "القالب",
  tabStyles: "الأنماط",
  pageText: "نص الصفحة",
  pageTextHint: "نص عادي. ابدأ السطر بـ ## للعنوان وبـ - لعنصر القائمة. اترك سطرًا فارغًا بين الفقرات.",
  policyTemplateNote: "قوالب السياسات مجرد نقطة انطلاق وليست استشارة قانونية. اطلب مراجعتها بما يناسب نشاطك والدول التي تبيع فيها.",
  livePreview: "معاينة مباشرة",
  draftPreviewOf: "معاينة مسودة",
  draftPreviewTitle: "معاينة مسودة {title}",
  reload: "إعادة التحميل",
  sectionSettings: "إعدادات القسم",
  showSection: "إظهار القسم",
  hideSection: "إخفاء القسم",
  sectionHiddenNote: "هذا القسم مخفي ولن يظهر في متجرك.",
  duplicate: "تكرار",
  deleteSection: "حذف القسم",
  noSectionSelected: "لم يتم تحديد أي قسم",
  noSectionSelectedHint: "اختر قسمًا من القائمة لتعديل نصه وصوره وتخطيطه.",
  showSections: "عرض الأقسام",
  deleteSectionConfirmTitle: "حذف هذا القسم؟",
  deleteSectionConfirmBody: "ستتم إزالة قسم {name} ومحتواه من المسودة. يمكنك التراجع باستخدام Ctrl+Z، أو إخفاء القسم بدلًا من حذفه.",
  publishConfirmTitle: "نشر تغييراتك؟",
  publishConfirmIntro: "تُحفظ تعديلاتك تلقائيًا كمسودة لا يراها سواك في المعاينة. يؤدي النشر إلى نسخ المسودة إلى متجرك المنشور:",
  publishPageChanged: "صفحة «{title}» (بها تغييرات غير منشورة)",
  publishPageUnchanged: "صفحة «{title}» (لا تغييرات جديدة)",
  publishThemeChanged: "القالب والأنماط (بها تغييرات غير منشورة)",
  publishThemeUnchanged: "القالب والأنماط (لا تغييرات جديدة)",
  publishOtherPagesNote: "تُنشر الصفحات الأخرى التي لها مسودات بشكل منفصل من شاشة الصفحات. تُحفظ مراجعة في كل مرة تنشر فيها، لتتمكّن من استعادة الإصدارات السابقة.",
  storeNotOpen: "متجرك نفسه غير مفتوح للعملاء بعد. عندما تكون جاهزًا، أطلقه من",
  dismiss: "إغلاق",
  allSaved: "تم حفظ كل التغييرات كمسودة",
  unsavedChanges: "تغييرات غير محفوظة",
  couldntSave: "تعذّر الحفظ",
  couldntSaveRetry: "تعذّر الحفظ — إعادة المحاولة",
  errSaveNetwork: "تعذّر الوصول إلى الخادم. تحقّق من اتصالك — سنحتفظ بتغييراتك هنا.",
  confirmLeaveUnsaved: "تعذّر حفظ آخر تغييراتك. هل تريد مغادرة هذه الصفحة على أي حال؟",
  errSaveFirst: "احفظ تغييراتك الحالية أولًا (راجع الخطأ في الأعلى).",
  errNetworkRetry: "تعذّر الوصول إلى الخادم. يُرجى المحاولة مرة أخرى.",
  errPublishUnsaved: "تعذّر حفظ آخر تغييراتك، لذا لم يُنشر أي شيء. أصلح الخطأ وحاول مرة أخرى.",
  errPublishNetwork: "تعذّر الوصول إلى الخادم. لم يُنشر أي شيء — يُرجى المحاولة مرة أخرى.",
  sectionAdded: "تمت إضافة {name} في الموضع {position} من {total}.",
  movedTo: "تم نقل {name} إلى الموضع {position} من {total}.",
  sectionShown: "تم إظهار {name}.",
  sectionHidden: "تم إخفاء {name}.",
  sectionDuplicated: "تم تكرار {name}.",
  sectionDeleted: "تم حذف القسم. اضغط Ctrl+Z للتراجع.",
  linkHome: "الرئيسية",
  linkShopAll: "كل المنتجات",
  linkCollection: "مجموعة: {title}",
  linkPage: "صفحة: {title}",
  loadingPreview: "جارٍ تحميل المعاينة",

  // Section list
  noSections: "لا تحتوي هذه الصفحة على أقسام بعد. أضف قسمًا أدناه.",
  pageSections: "أقسام الصفحة",
  dragToReorder: "اسحب لإعادة الترتيب",
  hidden: "مخفي",
  moveUp: "نقل {name} للأعلى",
  moveDown: "نقل {name} للأسفل",
  showItem: "إظهار {name}",
  hideItem: "إخفاء {name}",
  duplicateItem: "تكرار {name}",
  deleteItem: "حذف {name}",
  removeItem: "إزالة {name}",
  reorderHint: "اسحب الأقسام، أو استخدم الأسهم، أو اضغط Alt + ↑/↓ على قسم لإعادة ترتيبه.",
  addSection: "إضافة قسم",
  sectionLimit: "تم بلوغ الحد الأقصى للأقسام ({max})",
  sectionTypes: "أنواع الأقسام",

  // Section settings form
  textareaHint: "استخدم ## للعنوان و- لعناصر القائمة.",
  urlHint: "صفحة في متجرك مثل /products أو /pages/about، أو عنوان https:// كامل.",
  noCollectionsHint: "ليست لديك مجموعات بعد — تُعرض أحدث المنتجات.",
  newestProducts: "أحدث المنتجات",
  betweenHint: "بين {min} و{max}.",
  change: "تغيير",
  selectImage: "اختيار صورة",
  selectImageHint: "من مكتبة الوسائط أو برفع صورة جديدة",
  itemN: "العنصر {n}",
  noItems: "لا توجد عناصر بعد.",
  maxReached: "تم بلوغ الحد الأقصى ({max})",
  addItem: "إضافة عنصر",
  addItem_benefits: "إضافة ميزة",
  addItem_testimonials: "إضافة شهادة",
  addItem_faq: "إضافة سؤال",

  // Section registry
  section_hero: "البانر الرئيسي",
  section_hero_desc: "عنوان كبير مع صورة ودعوة إلى اتخاذ إجراء.",
  section_featured_products: "منتجات مميزة",
  section_featured_products_desc: "شبكة منتجات من مجموعة معيّنة أو من أحدث منتجاتك.",
  section_featured_collections: "قائمة المجموعات",
  section_featured_collections_desc: "روابط إلى مجموعاتك المنشورة.",
  section_image_text: "صورة مع نص",
  section_image_text_desc: "احكِ قصتك بجانب صورة.",
  section_promo_banner: "بانر ترويجي",
  section_promo_banner_desc: "شريط بارز لتسليط الضوء على عرض.",
  section_benefits: "المزايا",
  section_benefits_desc: "أبرز وعودك في الشحن والإرجاع والجودة والخدمة.",
  section_testimonials: "آراء العملاء",
  section_testimonials_desc: "اقتباسات من عملاء حقيقيين. لا تضف إلا آراء حقيقية لديك إذن بمشاركتها.",
  section_rich_text: "كتلة نصية",
  section_rich_text_desc: "عنوان وفقرات. يدعم تنسيقًا بسيطًا: ## للعناوين و- للقوائم.",
  section_newsletter: "الاشتراك في النشرة البريدية",
  section_newsletter_desc: "اجمع مشتركين موافقين لحملات التسويق عبر البريد الإلكتروني.",
  section_faq: "الأسئلة الشائعة",
  section_faq_desc: "الأسئلة المتكررة.",
  section_contact_info: "معلومات التواصل",
  section_contact_info_desc: "يعرض بيانات التواصل من إعدادات متجرك.",
  section_contact_form: "نموذج التواصل",
  section_contact_form_desc: "يمكن للعملاء إرسال رسالة إليك عبر البريد الإلكتروني.",
  field_heading: "العنوان",
  field_subheading: "العنوان الفرعي",
  field_buttonLabel: "نص الزر",
  field_buttonLink: "رابط الزر",
  field_imageMediaId: "الصورة",
  field_hero_imageMediaId: "صورة الخلفية",
  field_alignment: "المحاذاة",
  field_height: "الارتفاع",
  field_overlay: "تعتيم الصورة لتسهيل القراءة",
  field_collectionId: "المجموعة (اختياري)",
  field_featured_products_limit: "عدد المنتجات المعروضة",
  field_featured_collections_limit: "عدد المجموعات المعروضة",
  field_columns: "عدد الأعمدة على سطح المكتب",
  field_text: "النص",
  field_contact_info_text: "نص تمهيدي",
  field_imagePosition: "موضع الصورة",
  field_style: "النمط",
  field_benefits_items: "المزايا",
  field_testimonials_items: "الاقتباسات",
  field_faq_items: "الأسئلة",
  field_showEmail: "إظهار البريد الإلكتروني",
  field_showPhone: "إظهار رقم الهاتف",
  field_showAddress: "إظهار العنوان",
  itemField_title: "العنوان",
  itemField_text: "النص",
  itemField_quote: "الاقتباس",
  itemField_author: "اسم العميل",
  itemField_question: "السؤال",
  itemField_answer: "الإجابة",
  opt_alignment_left: "يسار",
  opt_alignment_center: "وسط",
  opt_height_small: "صغير",
  opt_height_medium: "متوسط",
  opt_height_large: "كبير",
  opt_imagePosition_left: "يسار",
  opt_imagePosition_right: "يمين",
  opt_style_primary: "لون العلامة التجارية",
  opt_style_dark: "داكن",
  opt_style_light: "فاتح",

  // Theme panel
  pickTheme: "اختر تصميمًا للبدء. يمكنك ضبط الألوان والخطوط بدقة من الأنماط.",
  premium: "مميز",
  current: "الحالي",
  useTheme: "استخدام {name}",
  switchToTheme: "التبديل إلى {name}؟",
  switchTheme: "تبديل القالب",
  switchThemeBody: "سيتم استبدال تخصيصات الأنماط (الألوان والخطوط وخيارات التخطيط) بالإعدادات الافتراضية لقالب {name}. ستُحفظ صفحاتك ومنتجاتك وقوائمك.",
  premiumThemeNote: "{name} قالب مميز ويتطلب باقة مدفوعة.",
  resetHome: "إعادة تعيين تخطيط الصفحة الرئيسية أيضًا",
  resetHomeHint: "يستبدل أقسام صفحتك الرئيسية بالتخطيط الموصى به لقالب {name}.",
  resetHomeSeeAfter: "ستراه بعد التبديل.",
  nothingChangesUntilPublish: "لن يتغيّر شيء في متجرك المنشور حتى تنشر.",
  theme_aurora_category: "تجارة عامة",
  theme_aurora_desc: "تخطيط أنيق ومتعدد الاستخدامات يناسب أغلب الكتالوجات.",
  theme_atelier_category: "الأزياء والملابس",
  theme_atelier_desc: "طباعة تحريرية وصور عمودية للملابس والإكسسوارات.",
  theme_voltage_category: "الإلكترونيات",
  theme_voltage_desc: "تخطيط عالي التباين مناسب لعرض المواصفات، للأجهزة والتقنية.",
  theme_bloom_category: "الجمال ومستحضرات التجميل",
  theme_bloom_desc: "ألوان هادئة وأشكال دائرية لعلامات العناية بالبشرة والتجميل.",
  theme_hearth_category: "المنزل والأثاث",
  theme_hearth_desc: "ألوان محايدة دافئة وصور واسعة للديكور الداخلي والأدوات المنزلية.",
  theme_harvest_category: "الأغذية والمنتجات المتخصصة",
  theme_harvest_desc: "تصميم ودود وشهي لمتاجر الطعام والمشروبات والمنتجات الفاخرة.",
  theme_pixel_category: "المنتجات الرقمية",
  theme_pixel_desc: "تخطيط بسيط وسريع للتنزيلات والقوالب والدورات.",

  // Styles panel
  logoFaviconIn: "يتم ضبط الشعار وأيقونة الموقع من",
  errHexColor: "استخدم لونًا سداسي عشريًا من 6 خانات مثل #1a2b3c",
  colorPicker: "منتقي لون {name}",
  styleUrlHint: "عنوان https:// كامل، أو مسار في متجرك مثل /products.",
  styleGroup_colors: "الألوان",
  styleGroup_typography: "الخطوط",
  styleGroup_layout: "التخطيط",
  styleGroup_headerFooter: "الرأس والتذييل",
  styleGroup_products: "المنتجات",
  style_colorPrimary: "لون العلامة التجارية",
  style_colorPrimaryText: "النص على لون العلامة التجارية",
  style_colorBackground: "خلفية الصفحة",
  style_colorSurface: "البطاقات واللوحات",
  style_colorText: "النص",
  style_colorMuted: "النص الثانوي",
  style_colorAccent: "التخفيضات والإبراز",
  style_fontHeading: "خط العناوين",
  style_fontBody: "خط النص",
  style_radius: "استدارة الزوايا",
  style_buttonStyle: "الأزرار",
  style_containerWidth: "عرض المحتوى",
  style_spacing: "التباعد",
  style_headerLayout: "تخطيط الرأس",
  style_stickyHeader: "رأس ثابت",
  style_announcementText: "نص شريط الإعلانات",
  style_announcementLink: "رابط الإعلان",
  style_footerText: "نص التذييل",
  style_socialInstagram: "رابط Instagram",
  style_socialFacebook: "رابط Facebook",
  style_socialX: "رابط X",
  style_socialTiktok: "رابط TikTok",
  style_productImageRatio: "شكل صورة المنتج",
  style_productCardStyle: "بطاقة المنتج",
  style_showVendor: "إظهار العلامة التجارية/المورّد على البطاقات",
  style_productPageLayout: "تخطيط صفحة المنتج",
  style_collectionColumns: "أعمدة الكتالوج (سطح المكتب)",
  font_system: "خط النظام (بدون زوائد)",
  font_serif: "خط النظام (بزوائد)",
  opt_radius_none: "مربّع",
  opt_radius_small: "صغير",
  opt_radius_medium: "متوسط",
  opt_radius_large: "كبير",
  opt_buttonStyle_solid: "مصمت",
  opt_buttonStyle_outline: "محدَّد",
  opt_buttonStyle_pill: "كبسولة",
  opt_containerWidth_narrow: "ضيّق",
  opt_containerWidth_normal: "عادي",
  opt_containerWidth_wide: "عريض",
  opt_spacing_compact: "مضغوط",
  opt_spacing_comfortable: "مريح",
  opt_spacing_airy: "واسع",
  opt_headerLayout_left: "الشعار على اليسار",
  opt_headerLayout_center: "الشعار في الوسط",
  opt_productImageRatio_square: "مربّع",
  opt_productImageRatio_portrait: "عمودي",
  opt_productImageRatio_landscape: "أفقي",
  opt_productCardStyle_plain: "بسيط",
  opt_productCardStyle_bordered: "بحدود",
  opt_productCardStyle_shadow: "بظل",
  opt_productPageLayout_side: "المعرض بجانب التفاصيل",
  opt_productPageLayout_stacked: "المعرض فوق التفاصيل",

  // Pages
  pagesDesc: "صفحتك الرئيسية وسياسات المتجر وأي صفحات إضافية مثل «من نحن» أو «الأسئلة الشائعة». تُحفظ التعديلات كمسودات حتى تنشرها.",
  noPagesDesc: "أنشئ صفحتك الأولى — مثل «من نحن» أو «معلومات الشحن».",
  colPage: "الصفحة",
  colUrl: "الرابط",
  colInNav: "في القائمة",
  colOrder: "الترتيب",
  homePage: "الصفحة الرئيسية",
  kind_home: "الرئيسية",
  kind_standard: "عادية",
  kind_policy: "سياسة",
  kind_contact: "تواصل",
  kind_faq: "أسئلة شائعة",
  kind_about: "من نحن",
  editInBuilder: "التعديل في المنشئ",
  storePolicies: "سياسات المتجر",
  storePoliciesDesc: "أُنشئت سياسات الاسترداد والخصوصية والشروط والشحن من قوالب جاهزة.",
  reviewed: "تمت المراجعة",
  policiesTemplatesNote: "القوالب نقطة انطلاق وليست استشارة قانونية. يجب مراجعتها — ويُفضَّل أن يكون ذلك من قِبل مختص قانوني — لتطابق طريقة تعامل نشاطك فعليًا مع الاسترداد والبيانات والشحن، وقوانين الأماكن التي تبيع فيها. عدّل نص كل سياسة من تبويب «النص» في المنشئ.",
  markPoliciesConfirmTitle: "تعليم السياسات كمراجَعة؟",
  markPoliciesConfirmBody: "أكّد أنك قرأت كل سياسة وكيّفتها مع نشاطك. هذا يحدّث قائمة الإطلاق فقط — ولا ينشر أي شيء.",
  markPoliciesReviewed: "تعليم السياسات كمراجَعة",
  liveUnpublishedChanges: "منشورة · تغييرات غير منشورة",

  // Page settings
  pageSettings: "إعدادات الصفحة",
  pageSettingsDesc: "العنوان والرابط وطريقة ظهور الصفحة في نتائج البحث.",
  kindPageAt: "صفحة {kind} على العنوان",
  previewDraft: "معاينة المسودة ↗",
  revisions: "المراجعات",
  revisionsDesc: "تُحفظ مراجعة في كل مرة تُنشر فيها هذه الصفحة. تؤدي الاستعادة إلى تحميلها في المسودة — ولا تُنشر إلا عندما تنشرها.",
  noRevisions: "لا توجد مراجعات بعد",
  noRevisionsDesc: "انشر الصفحة لإنشاء أول مراجعة.",
  latestPublished: "آخر نسخة منشورة",
  revisionMeta: "«{title}» · عدد الأقسام: {count}",
  revisionMeta_one: "«{title}» · قسم واحد",
  restoreConfirmTitle: "استعادة هذه المراجعة إلى المسودة؟",
  restoreConfirmBody: "سيُستبدل محتوى المسودة الحالية بهذه المراجعة. لن تتغيّر الصفحة المنشورة حتى تنشر.",
  restoreIntoDraft: "الاستعادة إلى المسودة",
  restore: "استعادة",
  publishing: "النشر",
  lastPublished: "آخر نشر",
  lastEdited: "آخر تعديل",
  draftNotLive: "تحتوي المسودة على تغييرات غير منشورة بعد.",
  discardConfirmTitle: "تجاهل تغييرات المسودة؟",
  discardConfirmBody: "ستعود المسودة إلى النسخة المنشورة. ستُفقد التعديلات غير المنشورة.",
  discardDraft: "تجاهل المسودة",
  unpublishPageConfirmTitle: "إلغاء نشر هذه الصفحة؟",
  unpublishPageConfirmBody: "لن يراها الزوار بعد الآن. ستعرض الروابط المؤدية إليها «غير موجودة». يمكنك نشرها مجددًا في أي وقت.",
  deletePage: "حذف الصفحة",
  deletePageBody: "يؤدي الحذف إلى إزالة الصفحة ومراجعاتها. ستتوقف روابط القوائم التي تشير إليها عن العمل.",
  deletePageConfirmTitle: "حذف «{title}»؟",

  // Page forms
  homeAlwaysAt: "تقع الصفحة الرئيسية دائمًا على العنوان",
  pageWillBeAt: "ستكون صفحتك على العنوان",
  slugRedirectHint: "عند تغيير رابط صفحة منشورة، تظل الروابط القديمة تعمل عبر إعادة توجيه.",
  showInNav: "إظهار في القائمة",
  showInNavHint: "يضيف هذه الصفحة تلقائيًا إلى رأس واجهة المتجر.",
  seoListing: "الظهور في محركات البحث",
  seoTitle: "عنوان SEO",
  seoTitleHint: "يكون افتراضيًا عنوان الصفحة.",
  seoDescription: "وصف SEO",
  seoDescriptionHint: "ملخص قصير يظهر في نتائج البحث.",
  hideFromSearch: "إخفاء عن محركات البحث",
  hideFromSearchHint: "يضيف وسم noindex. استخدمه لصفحات الشكر أو الصفحات الخاصة.",
  createPage: "إنشاء صفحة",
  createPageNote: "تبدأ الصفحة كمسودة. ستصمّمها في المنشئ بعد ذلك، ثم تنشرها عندما تكون جاهزة.",
  createAndEdit: "إنشاء وتعديل",
  saveSettings: "حفظ الإعدادات",

  // Navigation
  navDesc: "اختر الروابط التي تظهر في رأس متجرك وتذييله. تُنشر تغييرات القوائم بمجرد الحفظ.",
  groupStore: "المتجر",
  linksToDraftsTitle: "بعض الروابط تشير إلى صفحات غير منشورة",
  linksToDraftsBody: "{links} — سيرى الزوار «غير موجودة» حتى تنشر هذه الصفحات.",
  linksToDraftsBody_one: "{links} — سيرى الزوار «غير موجودة» حتى تنشر هذه الصفحة.",
  mainMenu: "القائمة الرئيسية",
  mainMenuDesc: "تظهر في رأس كل صفحة.",
  footerMenu: "قائمة التذييل",
  footerMenuDesc: "تظهر أسفل كل صفحة — مكان مناسب للسياسات وبيانات التواصل.",
  errAddLabel: "أضف تسمية",
  errChooseLink: "اختر رابطًا",
  errLinkFormat: "استخدم مسارًا مثل /products أو عنوان https:// كاملًا",
  errNetworkKept: "تعذّر الوصول إلى الخادم. ما زالت تغييراتك هنا — حاول مرة أخرى.",
  linkFallback: "الرابط",
  itemRemoved: "تمت إزالة {name}.",
  saveMenu: "حفظ القائمة",
  noLinks: "لا توجد روابط بعد. أضف أول رابط أدناه.",
  label: "التسمية",
  labelPh: "مثال: المتجر",
  linkTo: "الرابط إلى",
  customUrl: "رابط مخصص…",
  urlPh: "/pages/about أو https://…",
  maxLinks: "الحد الأقصى {max} رابطًا",
  addLink: "إضافة رابط",

  // Media
  mediaDesc: "صور للمنتجات والصفحات والبانرات، بالإضافة إلى الملفات الخاصة التي تُسلَّم للعملاء الذين يشترون منتجات رقمية.",
  tabImages: "الصور",
  tabPrivate: "الملفات الخاصة",
  searchByFilename: "البحث باسم الملف",
  searchImagesByFilename: "البحث عن الصور باسم الملف",
  missingAlt: "صور بدون نص بديل في هذه الصفحة: {count}. يصف النص البديل الصور لمستخدمي قارئات الشاشة ويساعد محركات البحث.",
  missingAlt_one: "صورة واحدة في هذه الصفحة بدون نص بديل. يصف النص البديل الصور لمستخدمي قارئات الشاشة ويساعد محركات البحث.",
  noFilesMatch: "لا توجد ملفات تطابق بحثك",
  noImagesYet: "لا توجد صور بعد",
  noPrivateYet: "لا توجد ملفات خاصة بعد",
  noImagesDesc: "ارفع صور المنتجات والبانرات وغيرها. تُحسَّن تلقائيًا.",
  noPrivateDesc: "الملفات الخاصة (PDF وZIP وEPUB وMP3 وMP4) متاحة للعملاء فقط عبر روابط تنزيل آمنة بعد الشراء.",
  missingAltTitle: "النص البديل مفقود",
  noAlt: "بلا نص بديل",
  colFile: "الملف",
  colSize: "الحجم",
  colUploaded: "تاريخ الرفع",
  added: "تاريخ الإضافة",
  deleteFileConfirmTitle: "حذف {name}؟",
  deleteFileConfirmBody: "لا يمكن حذف الملفات المرتبطة بمنتج أو التي اشتراها عميل بالفعل.",
  deleteFile: "حذف الملف",
  imageDetails: "تفاصيل الصورة",
  closeDetails: "إغلاق التفاصيل",
  copyUrl: "نسخ الرابط",
  altText: "النص البديل",
  altHint: "صِف محتوى الصورة، مثل «كوب خزفي أزرق على طاولة خشبية». اتركه فارغًا للصور الزخرفية فقط.",
  saveAlt: "حفظ النص البديل",
  deleteImageConfirmBody: "لا يمكن حذف الصور المستخدمة في منتج أو مجموعة أو صفحة أو كشعار — أزلها من هناك أولًا.",
  deleteImage: "حذف الصورة",
  uploadImages: "رفع صور",
  uploadPrivate: "رفع ملفات خاصة",
  uploadImagesHint: "الصور عامة لتتمكّن من الظهور في متجرك. حدّد صورة لإضافة نص بديل.",
  uploadPrivateHint: "لا تحصل الملفات الخاصة أبدًا على رابط عام. اربطها بمنتج رقمي ليتلقى المشترون روابط تنزيل آمنة ومؤقتة.",
  selectImageDetailsHint: "حدّد صورة لعرض تفاصيلها أو تعديل نصها البديل أو حذفها.",
  filesUploaded: "تم رفع الملفات: {count}.",
  filesUploaded_one: "تم رفع ملف واحد.",

  // Media picker
  chooseImage: "اختيار صورة",
  uploadNewImage: "رفع صورة جديدة",
  errLoadImages: "تعذّر تحميل الصور.",
  errNetwork: "خطأ في الشبكة — تحقّق من اتصالك وحاول مرة أخرى.",
  loadingImages: "جارٍ تحميل الصور",
  noImagesMatch: "لا توجد صور تطابق بحثك.",
  libraryEmpty: "مكتبة الوسائط فارغة. ارفع صورة في الأعلى.",
  imagePages: "صفحات الصور",
};

export default ar;
